export default __webpack_public_path__ + "static/slide3-mobile-93ad16d498778c09cec38940c980491d.png";